var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1726 2.36029C27.9823 3.11891 26.667 3.67064 25.2613 3.96585C24.1415 2.67904 22.5411 1.875 20.7692 1.875C17.373 1.875 14.6167 4.84222 14.6167 8.50163C14.6167 9.0214 14.6696 9.52519 14.7753 10.0105C9.66011 9.73377 5.12562 7.09876 2.08822 3.08443C1.55795 4.06678 1.25517 5.2064 1.25517 6.42003C1.25517 8.71778 2.34133 10.7464 3.99381 11.9348C2.98614 11.9028 2.03535 11.6017 1.20391 11.1089V11.1896C1.20391 14.4016 3.32577 17.0812 6.1437 17.6876C5.62785 17.8432 5.08317 17.9214 4.52167 17.9214C4.12517 17.9214 3.73829 17.881 3.36342 17.8036C4.1468 20.4353 6.41844 22.352 9.11222 22.4033C7.00638 24.1813 4.35105 25.241 1.46824 25.241C0.971618 25.241 0.480602 25.2108 0 25.1502C2.72341 27.0274 5.96027 28.125 9.43503 28.125C20.7572 28.125 26.9466 18.029 26.9466 9.27119C26.9466 8.98271 26.9418 8.69507 26.9314 8.41248C28.1337 7.47807 29.1782 6.31154 30 4.98268C28.8978 5.50918 27.7107 5.86578 26.466 6.02558C27.7372 5.2064 28.7128 3.90782 29.1726 2.36029",
    fill: "#4EA27D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ec5b7357.svg";
export { ForwardRef as ReactComponent };